import React from 'react'

import Wrapper from '../../components/Global/Wraper'

const Settings = () => {
  return (
    <React.Fragment>
      <Wrapper 
        pageTitle={`Settings`} 
      >
        
      </Wrapper>
      
    </React.Fragment>
  )
}

export default Settings